import styled from "styled-components";

//App.js
export const AppWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const Title = styled.h1`
  font-weight: normal;
  padding: 40px 40px 65px 40px;
  background-color: #2d3748;
  width: 100%;
  color: #f7fafc;
  font-size: 2.3em;
`;

export const Wrapper = styled.div`
  background-color: #4a5568;
  min-height: calc(100vh - 80px);
`;
